import { isoToFormatDate } from "../../functions/formatTime";
import uniqid from "uniqid";

import BlackBg from "../common/PopUp/BlackBg";
import FixedText from "../common/PopUp/FixedText";
import PopUpBody from "../common/PopUp/PopUpBody";
import PopUpContainer from "../common/PopUp/PopUpContainer";
import PopUpHeader from "../common/PopUp/PopUpHeader";
import ButtonGroup from "../common/PopUp/ButtonGroup";

import { useState } from "react";
import { fetchWithToken } from "../../functions/fetch";
import { updateItem } from "../../functions/local-update";
import { addSearchedField } from "../../functions/problem";

const ProblemPopUp = ({ problem, setShowPopUp, setProblems }) => {
  const itemName = "問題";
  const user = problem.reporterId;
  const progressOptions = ["未處理", "處理中", "已結案"];

  const [progress, setProgress] = useState(problem.progress);
  const [note, setNote] = useState(problem.note);
  const [errors, setErrors] = useState([]);

  const updateProblem = async () => {
    const formBody = {
      progress,
      note,
    };

    const res = await fetchWithToken(
      "PUT",
      `${process.env.REACT_APP_BACKEND_HOST}/api/problem/${problem._id}`,
      formBody,
    );
    if (res.status === 200) {
      setProblems((prev) => {
        const newProblem = problem;
        for (const key in formBody) {
          if (Object.hasOwnProperty.call(formBody, key)) {
            newProblem[key] = formBody[key];
          }
        }

        const newProblems = updateItem(prev, newProblem);
        addSearchedField(newProblems);

        return newProblems;
      });
      // setRefetchProblem(true);
      setShowPopUp(false);
    } else {
      if (res.errors) {
        setErrors(res.errors);
      } else {
        setErrors([{ msg: res.msg }]);
      }
    }
  };

  const onChangeValue = (event, setFunction) => {
    setFunction(event.target.value);
  };

  const cancel = () => {
    setShowPopUp(false);
  };

  return (
    <>
      <BlackBg cancel={cancel} />
      <PopUpContainer>
        <PopUpHeader itemName={itemName} />
        <PopUpBody>
          <FixedText label="會員編號" text={user.memberNumber} />
          {/* <FixedText label='Line暱稱' text={user.nickname} /> */}
          <FixedText label="會員姓名" text={user.name} />
          <FixedText label="會員房號" text={user.roomNumber ?? "無"} />
          <FixedText
            label="回報時間"
            text={isoToFormatDate(problem.createdAt, "yyyy/MM/dd HH:mm")}
          />

          <label htmlFor="text" className="justify-self-end">
            回報內容
          </label>
          <textarea
            id="text"
            className="col-span-3 pl-1"
            value={problem.description}
            disabled
          />

          <label htmlFor="note" className="justify-self-end">
            備註
          </label>
          <textarea
            id="note"
            className="col-span-3 bg-input-gray pl-1"
            value={note}
            onChange={(event) => onChangeValue(event, setNote)}
          />

          <label htmlFor="progress" className="justify-self-end">
            案件狀態
          </label>
          <select
            id="progress"
            className="bg-input-gray pl-1"
            value={progress}
            onChange={(event) => onChangeValue(event, setProgress)}
          >
            {progressOptions.map((text, index) => (
              <option className="bg-white" key={uniqid()} value={String(index)}>
                {text}
              </option>
            ))}
          </select>

          <ButtonGroup
            errors={errors}
            canDelete={false}
            cancelFunction={cancel}
            updateFunction={updateProblem}
          />
        </PopUpBody>
      </PopUpContainer>
    </>
  );
};

export default ProblemPopUp;
